var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('el-table',{key:"add",staticStyle:{"width":"97%"},attrs:{"data":_vm.compare,"border":""}},[_c('el-table-column',{attrs:{"label":"修改项","prop":"name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"修改前","prop":"before"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"修改后","prop":"after","class-name":"red-text"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ec9c40b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/recoder/smartHomework.vue
// module id = 2003
// module chunks = 0